module.exports = __webpack_public_path__ + "static/media/myprofile.e9a09095.svg";